import React, { useState } from 'react';

import FunctionDrawer from './FunctionDrawer';
import ControlDrawer from './ControlDrawer';

import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import * as classes from './BuilderHeader.module.css';

const BuilderHeader = ({
    connectorsClicked,
    ...props
}) => {

    const [functionDrawerOpen, setFunctionDrawerOpen] = useState(false);
    const [controlDrawerOpen, setControlDrawerOpen] = useState(false);
    const [controlAnchorEl, setControlAnchorEl] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);
    const controlOpen = Boolean(controlAnchorEl);
    const id = open ? 'nav-select-popover' : undefined;
    const controlId = controlOpen ? 'control-nav-select-popover' : undefined;

    const handleControlDrawerClose = () => {
        setControlDrawerOpen(false);
        setControlAnchorEl(null);
    };


    const handleClick = event => {
        setFunctionDrawerOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleOpenControlDrawer = event => {
        setControlDrawerOpen(true);
        setControlAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setFunctionDrawerOpen(false);
        setAnchorEl(null);
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <div style={props.mode === 'template' ? { marginLeft: 0 } : {}} className={classes.OperatorJoin}>
            <div className={classes.SelectContainer}>
                <FormControl
                    style={{ marginLeft: '0.8rem', marginRight: '1.5rem' }}
                    variant="outlined"
                    size="small"
                    className={classes.InputWrapper}
                >
                    <InputLabel
                        htmlFor="templateName"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Template Name
                    </InputLabel>
                    <Select
                        value={''}
                        id="templateName"
                        MenuProps={MenuProps}
                        name="templateName"
                        classes={{
                            root: classes.input
                        }}
                    >
                        <MenuItem
                            key={0}
                            value={0}
                        >
                            Template A
                        </MenuItem>
                    </Select>
                </FormControl>
                <FormControl variant="outlined" size="small" className={classes.InputWrapper}>
                    <InputLabel
                        htmlFor="buildingType"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Equipment
                    </InputLabel>
                    <Select
                        value={''}
                        id="equipment"
                        MenuProps={MenuProps}
                        name="equipment"
                        classes={{
                            root: classes.input
                        }}
                    >
                        <MenuItem
                            key={0}
                            value={0}
                        >
                            Equipment A
                        </MenuItem>
                    </Select>
                </FormControl>
            </div>
            <ClickAwayListener onClickAway={handleClose}>
                <div style={{ marginLeft: 15 }}>
                    <button
                        className={functionDrawerOpen ? classes.MathDrawerActive : classes.MathDrawer}
                        onClick={handleClick}
                    >
                        Math
                        <i className={`fas fa-chevron-${functionDrawerOpen ? 'down' : 'up'}`} style={{ 'fontSize': '12px', 'paddingLeft': '25px' }} aria-hidden="true" />
                    </button>
                    <Popper
                        placement="bottom-start"
                        id={id}
                        open={functionDrawerOpen}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                    >
                        <FunctionDrawer connectorsClicked={connectorsClicked} />
                    </Popper>
                </div>
            </ClickAwayListener>
            <ClickAwayListener onClickAway={handleControlDrawerClose}>
                <div style={{ marginLeft: 15 }}>
                    <button
                        className={controlDrawerOpen ? classes.ControlDrawerActive : classes.ControlDrawer}
                        onClick={handleOpenControlDrawer}
                    >
                        Control
                        <i className={`fas fa-chevron-${controlDrawerOpen ? 'down' : 'up'}`} style={{ 'fontSize': '12px', 'paddingLeft': '25px' }} aria-hidden="true" />
                    </button>
                    <Popper
                        placement="bottom-start"
                        id={controlId}
                        open={controlDrawerOpen}
                        anchorEl={controlAnchorEl}
                        onClose={handleControlDrawerClose}
                    >
                        <ControlDrawer connectorsClicked={connectorsClicked} />
                    </Popper>
                </div>
            </ClickAwayListener>
            <div
                role="none"
                style={{ marginLeft: 15 }}
                className={classes.SquareIcon}
                onClick={connectorsClicked}
            >
                <button>VARIABLE</button>
            </div>
            <div role="none" className={classes.SquareIcon} onClick={connectorsClicked}>
                <button>CONSTANT</button>
            </div>
        </div>
    );
};

export default BuilderHeader;
